export const ignoredMessages = [
  'Access is denied',
  'avast_submit',
  'Blocked a frame with origin "https://www.customink.com"',
  'ios 8.1.1 does not have a working localStorage.setItem',
  "Can't find variable: hilitor",
  'Design Icon failed to load',
  'event is not defined',
  'Failed to fetch',
  'fidoCallback',
  'frame is null',
  'gCrWeb.autofill',
  'InvalidStateError',
  'Not enough storage is available to complete this operation',
  'Script error',
  'SW registration failed',
  "TypeError: Can't call method on undefined",
  'TypeError: null is not an object',
  'unhandled rejection was null or undefined',
  "TypeError: Cannot get property 'drawImage' of undefined or null",
  "TypeError: Cannot get property 'clearRect' of undefined or null",
  /Failed to execute '.*' on 'CanvasRenderingContext2D'/,
  /null is not an object \(evaluating '..scale'\)/,
  /null is not an object \(evaluating '..clearRect'\)/,
  /Error: Minified React error/,
  /reading 'addPageAction'/,
  /ttd_dom_ready is not defined/,
  /reading 'publishMetrics'/,
  /getRestrictions is not a function/,
  /AutofillCallbackHandler/
];
